// extracted by mini-css-extract-plugin
export var wrapper = "ItemWithMenu-module--wrapper--6ewNJ";
export var wrapper__container = "ItemWithMenu-module--wrapper__container--pLN68";
export var wrapper__container__icon = "ItemWithMenu-module--wrapper__container__icon--3o-q_";
export var toggled = "ItemWithMenu-module--toggled--2MgbH";